module.exports = __webpack_public_path__ + "img/photo-28.2bda8be0.jpg";